import React, { ReactNode, createContext, useContext } from "react";

import { MessageAction } from "@accurx/api/apps";

import { useMessageActionsQuery } from "./hooks/useMessageActionsQuery";

export const AppsContext = createContext<
    | { messageActions: MessageAction[]; isLoading: boolean; isError: boolean }
    | undefined
>(undefined);

export const AppsProvider = ({
    children,
    workspaceId,
}: {
    children: ReactNode;
    workspaceId?: number | null;
}) => {
    const { data, isLoading, isError } = useMessageActionsQuery(workspaceId);

    return (
        <AppsContext.Provider
            value={{ messageActions: data?.actions ?? [], isLoading, isError }}
        >
            {children}
        </AppsContext.Provider>
    );
};

export const useAppsContext = () => {
    const context = useContext(AppsContext);
    if (context === undefined) {
        throw new Error(
            "useAppsContext can only be used by a child of a AppsProvider.",
        );
    }

    return context;
};
